/**
 * ISO tarih string'ini "12 Şubat 2026" formatına çevirir (tr-TR locale).
 * @param isoDate - ISO 8601 tarih string
 * @returns Formatlanmış tarih veya boş string
 */
export function formatDateLong(isoDate?: string): string {
  if (!isoDate) return "";
  try {
    const d = new Date(isoDate);
    return d.toLocaleDateString("tr-TR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return isoDate;
  }
}
